export default __webpack_public_path__ + "static/media/md-card-bg-fullstack-ai.a8f63fd2.png";